import { SidebarSection } from './sidebarUtils'

export const SIDEBAR_WIDTH = 250
export const SIDEBAR_COLLAPSED_WIDTH = 75
export const SIDEBAR_ITEM_HEIGHT = 32

export const OPEN_SECTIONS_STORAGE_KEY = 'sidebarOpenSections'

export const defaultOpenSections: Record<SidebarSection, boolean> = {
  [SidebarSection.MAIN]: true,
  [SidebarSection.PROJECTS]: false,
  [SidebarSection.RECRUITMENT]: false,
  [SidebarSection.ADMINISTRATION]: false,
  [SidebarSection.PERSONAL]: false,
  [SidebarSection.RESOURCING]: false,
}
